/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAccountsOverviewGetResponseFromDiscriminatorValue, type AccountsOverviewGetResponse } from '../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/overview
 */
export interface OverviewRequestBuilder extends BaseRequestBuilder<OverviewRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AccountsOverviewGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AccountsOverviewGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OverviewRequestBuilderUriTemplate = "{+baseurl}/accounts/overview";
/**
 * Metadata for all the requests in the request builder.
 */
export const OverviewRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OverviewRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        adapterMethodName: "send",
        responseBodyFactory:  createAccountsOverviewGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
